import { Link } from 'react-router-dom';
import { MapPin, Phone, Mail, Clock, Facebook, Instagram, Youtube, Twitter } from 'lucide-react';
import { SCHOOL, ALL_LINKS } from '@/data/content';

const Footer = () => (
  <footer data-testid="site-footer" className="bg-navy text-cream noise-overlay">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-16 sm:py-20">
      <div className="grid gap-12 md:grid-cols-2 lg:grid-cols-4">
        <div>
          <div className="flex items-center gap-3">
            <img src="/images/logo.png" alt="Ideal Public School logo" className="h-14 w-14 rounded-full ring-2 ring-gold bg-white object-cover" />
            <div>
              <p className="font-display text-xl font-black">Ideal Public School</p>
              <p className="text-[10px] font-bold uppercase tracking-[0.2em] text-cream/50">{SCHOOL.place}</p>
            </div>
          </div>
          <p className="mt-5 text-sm leading-relaxed text-cream/60">{SCHOOL.tagline}</p>
          <div className="mt-6 flex gap-3">
            {[
              { Icon: Facebook, label: 'Facebook' },
              { Icon: Instagram, label: 'Instagram' },
              { Icon: Youtube, label: 'YouTube' },
              { Icon: Twitter, label: 'Twitter' },
            ].map(({ Icon, label }) => (
              <a key={label} href="#" aria-label={label} data-testid={`social-${label.toLowerCase()}`} className="flex h-10 w-10 items-center justify-center rounded-full border border-cream/20 text-cream/70 transition-all hover:border-gold hover:text-gold hover:-translate-y-0.5">
                <Icon className="h-4 w-4" />
              </a>
            ))}
          </div>
        </div>

        <div>
          <h3 className="text-xs font-bold uppercase tracking-[0.25em] text-gold">Explore</h3>
          <ul className="mt-5 grid grid-cols-2 gap-x-4 gap-y-2.5">
            {ALL_LINKS.map((l) => (
              <li key={l.path}>
                <Link to={l.path} data-testid={`footer-link-${l.label.toLowerCase().replace(/\s/g, '-')}`} className="text-sm text-cream/70 transition-colors hover:text-gold">
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h3 className="text-xs font-bold uppercase tracking-[0.25em] text-gold">Contact</h3>
          <ul className="mt-5 space-y-4 text-sm text-cream/70">
            <li className="flex gap-3"><MapPin className="h-4 w-4 mt-0.5 text-gold shrink-0" />{SCHOOL.address}</li>
            <li className="flex gap-3">
              <Phone className="h-4 w-4 mt-0.5 text-gold shrink-0" />
              <span className="flex flex-col">
                {SCHOOL.phones.map((p) => (
                  <a key={p} href={`tel:${p.replace(/\s/g, '')}`} data-testid={`footer-phone-${p.slice(-5)}`} className="hover:text-gold transition-colors">{p}</a>
                ))}
              </span>
            </li>
            <li className="flex gap-3"><Mail className="h-4 w-4 mt-0.5 text-gold shrink-0" /><a href={`mailto:${SCHOOL.email}`} data-testid="footer-email" className="hover:text-gold transition-colors break-all">{SCHOOL.email}</a></li>
          </ul>
        </div>

        <div>
          <h3 className="text-xs font-bold uppercase tracking-[0.25em] text-gold">School Hours</h3>
          <ul className="mt-5 space-y-4 text-sm text-cream/70">
            <li className="flex gap-3"><Clock className="h-4 w-4 mt-0.5 text-gold shrink-0" />Classes: {SCHOOL.hours}</li>
            <li className="flex gap-3"><Clock className="h-4 w-4 mt-0.5 text-gold shrink-0" />Office: {SCHOOL.officeHours}</li>
          </ul>
          <Link to="/admissions" data-testid="footer-cta" className="mt-6 inline-flex items-center rounded-full bg-gold px-5 py-2.5 text-sm font-bold text-navy transition-all hover:-translate-y-0.5 hover:bg-gold-dark">
            Admissions Open {SCHOOL.session}
          </Link>
        </div>
      </div>
    </div>
    <div className="border-t border-cream/10">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-5 flex flex-col sm:flex-row items-center justify-between gap-2 text-xs text-cream/40">
        <p>© {new Date().getFullYear()} Ideal Public School, {SCHOOL.place}. All rights reserved.</p>
        <p>Where Education Meets Excellence</p>
      </div>
    </div>
  </footer>
);

export default Footer;
